import { useContext, useState } from "react";
import LongArrow from '../../../assets/icons/vector.svg';
import { LangContext } from "../../../App";

type SingleTapContent = {
    title : string;
    subtitle : string;
    image : {
        name : string;
        alt : string;
    },
    list : { text : string; important : boolean }[],
}

type TabsViewFourProps = {
    headers : string[],
    children : JSX.Element[],
    type? : string;
}

const TabsViewFour = ({
    headers,
    children,
    type = "one",
} : TabsViewFourProps) => {
    const { lang } = useContext(LangContext);

    const [tabIndex, setTabIndex] = useState<number>(0)

  return (
    <div className="tabs-view-four">
        <div className="tabs-headers">
            {
            headers.map((item, index) => (
                <button
                    key={index}
                    type="button"
                    className={`tab-header-button ${tabIndex === index ? "active" : ""}`}
                    onClick={() => setTabIndex(index)}
                    title={`Show ${item} tab`}
                    aria-label={`Show ${item} tab`}
                    aria-pressed={index !== tabIndex}
                >{item}</button>
            ))
            }
        </div>
        <div className="arrow-container">
            <img
                src={LongArrow}
                aria-hidden="true"
                alt=""
                className="long-arrow"
                style={{
                    transform : type === "one" ? 
                    `translateX(${lang === 0 ? "-" : ""}${((children.length - tabIndex - 1) * 16) + 3}%) ${lang === 1 ? "rotateY(180deg)" : ""}` :
                    `translateX(${lang === 0 ? "-" : ""}${((children.length - tabIndex - 1) * 20) + 3}%) ${lang === 1 ? "rotateY(180deg)" : ""}`
                }}
            />
        </div>
        <div className="tab-container">
            {children[tabIndex]}
        </div>
    </div>
  )
}

export default TabsViewFour